module.exports = __webpack_public_path__ + "media/images/products/marketplace/2-6350871e2a0e1794ac8440f2cfc69116.png";